import React from 'react';
import './ui.css';

/**
 * Segmented control — track #F1EDEA, radius 9px, padding 3px; active pill is white
 * with a 1px shadow. Used by the blog editor's Markdown / Split / Preview switch.
 */
export default function Segmented({ options = [], value, onChange, className = '', label }) {
  return (
    <div className={`sv-segmented ${className}`} role="tablist" aria-label={label}>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`sv-segmented__item ${isActive ? 'is-active' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.icon && <i className={`bx ${opt.icon}`} aria-hidden="true" />}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
